module.exports = __webpack_public_path__ + "img/ccqh_img.8195b0c4.jpg";